import { render, staticRenderFns } from "./NormalDocument.vue?vue&type=template&id=d5038cd2&scoped=true&"
import script from "./NormalDocument.vue?vue&type=script&lang=js&"
export * from "./NormalDocument.vue?vue&type=script&lang=js&"
import style0 from "./NormalDocument.vue?vue&type=style&index=0&id=d5038cd2&prod&lang=scss&scoped=true&"
import style1 from "./NormalDocument.vue?vue&type=style&index=1&id=d5038cd2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5038cd2",
  null
  
)

export default component.exports